import { setImportDryRun } from './updateMigrationService';
import retryImport from './retryImportService';
import type { RetryImportResult } from './retryImportService';

/**
 * Re-runs the dry-run preview on the SAME migration: ensures the dry-run flag is set, then re-enqueues
 * the import (reusing the already exported + transformed artifacts). Use after resolving a prerequisite
 * in the target org so the plan and the live target-org readiness checks are re-evaluated and the
 * confidence score refreshes. A dry run applies nothing to the target org.
 */
export const runDryRunAgain = async (
    bearerToken: string,
    migrationId: string
): Promise<RetryImportResult> => {
    await setImportDryRun(bearerToken, migrationId, true);
    return retryImport(bearerToken, migrationId);
};

export default runDryRunAgain;
